import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import {Tooltip} from "react-bootstrap";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";

/* Utilities */
import { trans } from '~/utilities';

/* Components */
import FavoritesModal from '~/components/favorites-toggle/components/FavoritesModal';

/* Custom */
import eventBus, { EVENTS } from '~/custom/eventBus';

/* Config */
import { reactToastifyConfig } from '~/config';

export default function FavoritesToggle({ vehicleId, showLabel = false, favorites, vehicleDetail = false, userLoggedIn = false, tooltipPlacement = 'top', extranetLoginUrl, extranetRegisterUrl, saveFavoriteUrl, removeFavoriteUrl, getFavoritesUrl }) {
    const [isFavorite, setIsFavorite] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);

    const fetchFavorites = async () => {
        try {
            const response = await axios.get(getFavoritesUrl);
            const favorites = response.data.vehicles;
            if (favorites && Array.isArray(favorites)) {
                const isFavorite = favorites.some(vehicle => vehicle.id === vehicleId);
                setIsFavorite(isFavorite);
            } else {
                toast.error('Er is iets verkeerd gegaan bij het ophalen van favorieten.');
            }
        } catch (error) {
            toast.error('Er is iets verkeerd gegaan, probeer het nogmaals.');
        }
    };

    useEffect(() => {
        toast.configure(reactToastifyConfig);
        if (favorites) {
            const isFavorite = favorites.some(vehicle => vehicle.id === vehicleId);
            setIsFavorite(isFavorite);
        } else if (vehicleDetail) {
            fetchFavorites();
        }
    }, [favorites, vehicleId, vehicleDetail]);

    const addFavorite = async (event) => {
        event.preventDefault();

        try {
            const response = await axios.post(saveFavoriteUrl, { vehicleUuid: vehicleId });

            if (response.data.success) {
                setIsFavorite(true);
                toast.success('Voertuig toegevoegd aan favorieten.');
                eventBus.emit(EVENTS.FAVORITES_UPDATED);

                if (!userLoggedIn) {
                    const hasAddedFavoriteBefore = localStorage.getItem('hasAddedFavoriteBefore');

                    if (!hasAddedFavoriteBefore) {
                        setModalOpen(true);
                        localStorage.setItem('hasAddedFavoriteBefore', 'true');
                    }
                }
            } else {
                toast.error('Er is iets verkeerd gegaan, probeer het nogmaals.');
            }
        } catch (error) {
            toast.error('Er is iets verkeerd gegaan, probeer het nogmaals.');
        }
    };

    const removeFavorite = async (event) => {
        event.preventDefault();

        try {
            const response = await axios.post(removeFavoriteUrl, { vehicleUuid: vehicleId });
            if (response.data.success) {
                setIsFavorite(false);
                toast.info('Voertuig verwijderd uit favorieten.');
                eventBus.emit(EVENTS.FAVORITES_UPDATED);
            } else {
                toast.error('Er is iets verkeerd gegaan, probeer het nogmaals.');
            }
        } catch (error) {
            toast.error('Er is iets verkeerd gegaan, probeer het nogmaals.');
        }
    };

    return (
        <div className={`favorite-toggle ${isFavorite ? 'is-favorite' : ''}`}>
            <OverlayTrigger
                placement={tooltipPlacement}
                overlay={
                    <Tooltip>
                        {isFavorite ? trans(`app.favorites.remove.tooltip`) : trans(`app.favorites.save.tooltip`)}
                    </Tooltip>
                }
            >
                <button className={`btn btn-none btn-block p-0 btn--reversed gap-2 text-muted--60 font-weight-normal text--sm ${showLabel ? '' : 'btn--circle'}`} title={isFavorite ? 'Verwijderen' : 'Opslaan'} onClick={isFavorite ? removeFavorite : addFavorite}>
                    <div className="btn__icon-wrapper" style={{ opacity: 1, transform: 'none' }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                            <g fill="none" fillRule="evenodd">
                                <polygon points="0 0 20 0 20 20 0 20"/>
                                <path className="outer-heart" fill="currentColor" fillRule="nonzero" d="M13.75,2.5 C12.3,2.5 10.9083333,3.175 10,4.24166667 C9.09166667,3.175 7.7,2.5 6.25,2.5 C3.68333333,2.5 1.66666667,4.51666667 1.66666667,7.08333333 C1.66666667,10.2333333 4.5,12.8 8.79166667,16.7 L10,17.7916667 L11.2083333,16.6916667 C15.5,12.8 18.3333333,10.2333333 18.3333333,7.08333333 C18.3333333,4.51666667 16.3166667,2.5 13.75,2.5 Z"/>
                                <path className="inner-heart" fill="currentColor" fillRule="nonzero" d="M10.0833333,15.4583333 L10,15.5416667 L9.91666667,15.4583333 C5.95,11.8666667 3.33333333,9.49166667 3.33333333,7.08333333 C3.33333333,5.41666667 4.58333333,4.16666667 6.25,4.16666667 C7.53333333,4.16666667 8.78333333,4.99166667 9.225,6.13333333 L10.7833333,6.13333333 C11.2166667,4.99166667 12.4666667,4.16666667 13.75,4.16666667 C15.4166667,4.16666667 16.6666667,5.41666667 16.6666667,7.08333333 C16.6666667,9.49166667 14.05,11.8666667 10.0833333,15.4583333 Z"/>
                            </g>
                        </svg>
                    </div>

                    {showLabel ? (
                        <span className="btn__text">{isFavorite ? 'Verwijderen' : 'Opslaan'}</span>
                    ) : null}
                </button>
            </OverlayTrigger>
            {!userLoggedIn && modalOpen && <FavoritesModal modalOpen={modalOpen} setModalOpen={setModalOpen} extranetLoginUrl={extranetLoginUrl} extranetRegisterUrl={extranetRegisterUrl} />}
        </div>
    );
}
